module.exports = __webpack_public_path__ + "static/k2Res1-33687b4bb0003ce1be087bc108e84b93.png";